import { render, staticRenderFns } from "./ExpertTalkEdit.vue?vue&type=template&id=703006fc"
import script from "./ExpertTalkEdit.vue?vue&type=script&lang=js"
export * from "./ExpertTalkEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports